import { render, staticRenderFns } from "./AdminLecturesRootView.vue?vue&type=template&id=59cfe8b3"
import script from "./AdminLecturesRootView.vue?vue&type=script&lang=js"
export * from "./AdminLecturesRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports